module.exports = __webpack_public_path__ + "img/brokers_hero.9e5ead1b.jpg";